import { send, sendMultipart } from '../helpers/requests';
import { getToken } from '../helpers/getToken';
import { DataProviderParamsModel } from './dataProviderParamsModel';
import {
  setPropertyImages,
  setPropertyWinnerPhoto,
  setBlogPostImages,
} from '../helpers/setPropertyImages';
import { PropertyRequest } from '../types/property';
import {
  ImageIDS,
  PropertyImage,
  PropertyImagesParams,
} from '../types/propertyImages';
import { ReportParams, UsersReport, ReportDateParams } from '../types/reports';
import { Coupon } from '../types/coupons';
import { BlogPostImage } from '../types/blogPost';
import { Bonus } from '../types/bonus';
import { GeneralContentItem } from '../types/generalContent';

const storeImagesAsync = (
  property: string,
  galleryImages: Array<PropertyImage>,
  galleryImagesMobile: Array<PropertyImage>,
  floorImage: PropertyImage | undefined,
  locationMap: PropertyImage | undefined,
  badroomImage: PropertyImage | undefined,
  bathroomImage: PropertyImage | undefined,
  outspaceImage: PropertyImage | undefined,
  cardImage: PropertyImage | undefined,
  mobileCardImage: PropertyImage | undefined,
  emailGalleryImage: PropertyImage | undefined,
) => {
  let imageIDS: ImageIDS = { ids: [], images: [] };
  // eslint-disable-next-line array-callback-return
  galleryImages.map((g, i) => {
    imageIDS.images.push(g);
    imageIDS.ids.push(`galleryImage_${i}`);
  });
  galleryImagesMobile.map((g, i) => {
    imageIDS.images.push(g);
    imageIDS.ids.push(`galleryImageMobile_${i}`);
  });
  if (floorImage) {
    imageIDS.images.push(floorImage);
    imageIDS.ids.push('floorPlanImage');
  }
  if (locationMap) {
    imageIDS.images.push(locationMap);
    imageIDS.ids.push('locationMapImage');
  }
  if (badroomImage) {
    imageIDS.images.push(badroomImage);
    imageIDS.ids.push('badroomImage');
  }
  if (bathroomImage) {
    imageIDS.images.push(bathroomImage);
    imageIDS.ids.push('bathroomImage');
  }
  if (outspaceImage) {
    imageIDS.images.push(outspaceImage);
    imageIDS.ids.push('outspaceImage');
  }
  if (cardImage) {
    imageIDS.images.push(cardImage);
    imageIDS.ids.push('cardImage');
  }
  if (mobileCardImage) {
    imageIDS.images.push(mobileCardImage);
    imageIDS.ids.push('mobileCardImage');
  } else if (galleryImagesMobile && galleryImagesMobile.length) {
    imageIDS.images.push(galleryImagesMobile[0]);
    imageIDS.ids.push('mobileCardImage');
  }
  if (emailGalleryImage) {
    imageIDS.images.push(emailGalleryImage);
    imageIDS.ids.push('emailGalleryImage');
  }
  const multipartData = imageIDS.images.map((image, id) => {
    return { image: image, id: imageIDS.ids[id] };
  });
  return sendMultipart({
    method: 'POST',
    url: '/properties/' + property + '/images',
    multipartData,
    token: getToken(),
  });
};
const storeBlogPostImagesAsync = (
  post: string,
  previewImage: PropertyImage | undefined,
) => {
  let imageIDS: ImageIDS = { ids: [], images: [] };
  // eslint-disable-next-line array-callback-return
  if (previewImage) {
    imageIDS.images.push(previewImage);
    imageIDS.ids.push('previewImage');
  }
  const multipartData = imageIDS.images.map((image, id) => {
    return { image: image, id: imageIDS.ids[id] };
  });
  console.log('multipartData', multipartData);

  return sendMultipart({
    method: 'POST',
    url: '/blogs/' + post + '/images',
    multipartData,
    token: getToken(),
  }).then((response) => {
    return { data: response.data, status: 'OK' };
  });
};

const dataProvider = {
  storeBlogPostImagesAsync: async (
    post: string,
    previewImage: File | undefined,
  ) => {
    // let imageIDS: ImageIDS = { ids: [], images: [] };
    // // eslint-disable-next-line array-callback-return
    // if (previewImage) {
    //   imageIDS.images.push(previewImage);
    //   imageIDS.ids.push("previewImage");
    // }
    // const multipartData = imageIDS.images.map((image, id) => {
    //   return { image: image, id: imageIDS.ids[id] };
    // });
    // console.log("multipartData2", multipartData);
    // return sendMultipart({
    //   method: "POST",
    //   url: "/blogs/" + post + "/images",
    //   multipartData,
    //   token: getToken(),
    // }).then((response) => {
    //   return { data: response.data, status: "OK" };
    // });
    if (!previewImage) {
      return { data: null, status: 'SKIPPED' };
    }

    const multipartData = [{ id: 'previewImage', image: previewImage }];

    try {
      const response = await sendMultipart({
        method: 'POST',
        url: '/blogs/' + post + '/images',
        multipartData,
        token: getToken(),
      });

      return { data: response.data, status: 'OK' };
    } catch (error: any) {
      console.error('Upload error:', error.response || error.request || error);
      throw new Error(
        error.response?.data?.error || error.message || 'Upload failed',
      );
    }
  },

  storeBlogPostImagesAssetsAsync: (
    post: string,
    galleryImages: Array<BlogPostImage>,
    galleryImagesMobile: Array<BlogPostImage>,
  ) => {
    console.log('galleryImages: ', galleryImages);
    console.log('galleryImagesMobile: ', galleryImagesMobile);
    let imageIDS: ImageIDS = { ids: [], images: [] };
    // eslint-disable-next-line array-callback-return

    if (galleryImages) {
      galleryImages.map((g, i) => {
        imageIDS.images.push(g);
        imageIDS.ids.push(`${post}/assets/galleryImage_${i}`);
      });
    }
    if (galleryImagesMobile) {
      galleryImagesMobile.map((g, i) => {
        imageIDS.images.push(g);
        imageIDS.ids.push(`${post}/assets/galleryImageMobile_${i}`);
      });
    }
    const multipartData = imageIDS.images.map((image, id) => {
      return { image: image, id: imageIDS.ids[id] };
    });
    return sendMultipart({
      method: 'POST',
      url: '/blogs/' + post + '/assets/images',
      multipartData,
      token: getToken(),
    })
      .then((response) => {
        return { data: response.data, status: 'OK' };
      })
      .catch((err) => {
        console.log('assets images error: ', err);
      });
  },
  storeBlogPostAssetsImageAsync: (files: Array<any>) => {
    let imageIDS: ImageIDS = { ids: [], images: [] };
    // eslint-disable-next-line array-callback-return

    if (files) {
      files.map((g, i) => {
        imageIDS.images.push(g);
        imageIDS.ids.push(`blog-assets/galleryImage_${i}`);
      });
    }

    const multipartData = imageIDS.images.map((image, id) => {
      return { image: image, id: imageIDS.ids[id] };
    });
    return sendMultipart({
      method: 'POST',
      url: '/blogs/assets/image',
      multipartData,
      token: getToken(),
    })
      .then((response) => {
        return { data: response.data, status: 'OK' };
      })
      .catch((err) => {
        console.log('assets images error: ', err);
        throw err.data.error;
      });
  },
  storeCharityImageAsync: (charityId: string, files: Array<any>) => {
    let imageIDS: ImageIDS = { ids: [], images: [] };
    // eslint-disable-next-line array-callback-return

    if (files) {
      files.map((g, i) => {
        imageIDS.images.push(g);
        imageIDS.ids.push(`image`);
      });
    }

    const multipartData = imageIDS.images.map((image, id) => {
      return { image: image, id: imageIDS.ids[id] };
    });
    return sendMultipart({
      method: 'POST',
      url: `/charities/${charityId}/images`,
      multipartData,
      token: getToken(),
    })
      .then((response) => {
        return { data: response.data, status: 'OK' };
      })
      .catch((err) => {
        console.log('assets images error: ', err);
        throw err.data.error;
      });
  },
  getBlogAssets: () => {
    return send({
      method: 'get',
      url: 'blogs/assets/get',
      data: {},
      token: getToken(),
    })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return { data: { list: [] } };
      });
  },
  deleteBlogAssetsImage: (Key) => {
    return send({
      method: 'delete',
      url: 'blogs/assets/delete',
      data: {
        Key: Key,
      },
      token: getToken(),
    }).then((response) => {
      return response;
    });
  },
  getList: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: resource === 'users/referrals' ? resource : `/${resource + '/get'}`,
      data: params,
      token: getToken(),
    }).then((response) => {
      const record = resource.split('/');
      console.log('record: ', record);
      const competitions = response.data.competitions
        ? response.data.competitions
        : '';
      const totalCredits = response.data.total ? response.data.total : 0;
      const generalSettings = response.data.generalSettings
        ? response.data.generalSettings
        : '';
      let data =
        resource !== 'users/referrals'
          ? response.data[record[0]].map((item) => {
              item.id = item._id;
              return item;
            })
          : response.data[record[1]].map((item) => {
              item.id = item._id;
              return item;
            });
      return {
        balance: totalCredits,
        competitions: competitions,
        data,
        total: response.data.allCount ? response.data.allCount : data.length,
        generalSettings,
      };
    });
  },
  getPosts: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: `/${resource + '/get'}`,
      data: params,
      token: getToken(),
    }).then((response) => {
      const record = resource.split('/');

      let data = response.data[record[0]].map((item) => {
        item.id = item._id;
        return item;
      });
      return {
        data,
        total: response.data.allCount ? response.data.allCount : data.length,
      };
    });
  },
  getHomePageList: (resource: string, params: DataProviderParamsModel) => {
    const page =
      params.pagination && params.pagination.page
        ? params.pagination.page
        : undefined;
    const perPage =
      params.pagination && params.pagination.perPage
        ? params.pagination.perPage
        : undefined;
    return send({
      method: 'get',
      url: `/${resource}/?number=${page}&count=${perPage}&filter=${params.filter?.isClosed}`,
      data: params,
      token: getToken(),
    }).then((response) => {
      let homes = response.data.homes.map((item) => {
        item.id = item._id;
        return item;
      });
      let raffles = response.data.raffles.map((item) => {
        item.id = item._id;
        return item;
      });
      return {
        data: { homes, raffles },
        total: response.data.allCount ? response.data.allCount : homes.length,
      };
    });
  },
  createHomePage: (data: any) => {
    return send({
      method: 'post',
      url: `homes`,
      data: data,
      token: getToken(),
    }).then((response) => {
      return response;
    });
  },
  updateHomePage: (id: string, data: any) => {
    return send({
      method: 'patch',
      url: `homes/${id}`,
      data: data,
      token: getToken(),
    }).then((response) => {
      return response;
    });
  },
  uploadHomeImages: (path: any, files: { images: Array<PropertyImage> }) => {
    let imageIDS: ImageIDS = { ids: [], images: [] };
    // eslint-disable-next-line array-callback-return
    files.images.map((g, i) => {
      imageIDS.images.push(g);
      imageIDS.ids.push(`images_${i}`);
    });
    const multipartData = imageIDS.images.map((image, id) => {
      return { image: image, id: imageIDS.ids[id] };
    });

    return sendMultipart({
      method: 'POST',
      url: `${path.source}/` + path.id + `/${path.type}`,
      multipartData,
      token: getToken(),
    });
  },
  getDreamhomeList: (resource: string, params: DataProviderParamsModel) => {
    const page =
      params.pagination && params.pagination.page
        ? params.pagination.page
        : undefined;
    const perPage =
      params.pagination && params.pagination.perPage
        ? params.pagination.perPage
        : undefined;
    return send({
      method: 'get',
      url: `/${resource}/?number=${page}&count=${perPage}&filter=${params.filter?.isClosed}`,
      data: params,
      token: getToken(),
    }).then((response) => {
      const record = resource.split('/');
      let data = response.data[record[0]].map((item) => {
        item.id = item._id;
        return item;
      });
      return {
        data,
        total: response.data.allCount ? response.data.allCount : data.length,
      };
    });
  },
  getWeeklySubscriptionDraws: (
    resource: string,
    params: DataProviderParamsModel,
  ) => {
    const page =
      params.pagination && params.pagination.page
        ? params.pagination.page
        : undefined;
    const perPage =
      params.pagination && params.pagination.perPage
        ? params.pagination.perPage
        : undefined;
    return send({
      method: 'get',
      url: `/${resource}/?number=${page}&count=${perPage}&filter=${params.filter?.isClosed}`,
      data: params,
      token: getToken(),
    }).then((response) => {
      const record = resource.split('/');
      let data = response.data['draws'].map((item) => {
        item.id = item._id;
        return item;
      });
      return {
        data,
        total: response.data.allCount ? response.data.allCount : data.length,
      };
    });
  },
  getOne: (resource: string, params: DataProviderParamsModel) => {
    if (resource === 'dreamHome') {
      resource = 'raffles';
    }
    if (resource === 'staffUsers') {
      resource = 'staff';
    }
    return send({
      method: 'get',
      url: `/${resource}/${params.id}`,
      token: getToken(),
    }).then((response) => {
      if (!response.data) {
        return { data: { id: '' } };
      }
      let item = response.data;
      item.id = response.data._id;
      if (response.data.email) {
        // item.affiliate.email = response.data.email
      }
      if (resource === 'raffles') {
        let newItem = setPropertyImages(item);
        return {
          data: newItem,
        };
      }
      if (resource === 'winners') {
        let newItem = setPropertyWinnerPhoto(item);
        return {
          data: newItem,
        };
      }
      if (resource === 'blogs') {
        let newItem = setBlogPostImages(item);
        return {
          data: newItem,
        };
      }
      return {
        data: item,
      };
    });
  },
  create: (resource: string, params: DataProviderParamsModel) => {
    if (
      resource === 'winners' ||
      resource === 'prizeCategories' ||
      resource === 'subcategories'
    ) {
      return sendMultipart({
        method: 'post',
        url: `/${resource}`,
        token: getToken(),
        multipartData: params.data,
        params: { affiliateUsers: params.affiliates },
      }).then((response) => {
        let responseData = response.data;
        responseData.id = response.data._id;
        return {
          data: responseData,
        };
      });
    } else {
      // resource = resource ==='users'? 'users/cms': resource
      return send({
        method: 'post',
        url: `/${resource}`,
        token: getToken(),
        data: params.data,
      })
        .then((response) => {
          let responseData = response.data;
          responseData.id = response.data._id;
          return {
            data: responseData,
          };
        })
        .catch((error) => {
          throw error.data.error;
        });
    }
  },
  update: (resource: string, params: DataProviderParamsModel) => {
    if (
      resource === 'winners' ||
      resource === 'prizeCategories' ||
      resource === 'subcategories'
    ) {
      return sendMultipart({
        method: 'put',
        url: `/${resource}/${params.id}`,
        multipartData: params.data,
        params,
        token: getToken(),
      })
        .then((response) => {
          response.data.id = response.data._id
            ? response.data._id
            : new Date().getTime();
          return {
            data: response.data,
          };
        })
        .catch((error) => {
          throw error.data.error;
        });
    }
    return send({
      method: 'put',
      url: `/${resource}/${params.id}`,
      token: getToken(),
      data: params.data,
    }).then((response) => {
      response.data.id = response.data._id;
      return {
        data: response.data,
      };
    });
  },
  delete: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'delete',
      url: `/${resource}/${params.id}`,
      token: getToken(),
      // data: { id: params.id },
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  deleteMany: (resource: string, params: DataProviderParamsModel) => {
    const data = {
      ids: params.ids,
      code: params.code,
      isActive: params.isActive,
    };
    return send({
      method: 'delete',
      url: `/${resource}/delete-many/admin`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: [response.data],
      };
    });
  },
  createProperty: (data: PropertyRequest, images: PropertyImagesParams) => {
    return send({
      method: 'post',
      url: `properties`,
      token: getToken(),
      data,
    }).then((response) => {
      const id = response.data._id;
      if (
        images.galleryImages.length > 0 ||
        images.galleryImagesMobile.length > 0 ||
        images.floorPlanImage ||
        images.locationMapImage ||
        images.badroomImage ||
        images.bathroomImage ||
        images.outspaceImage ||
        images.cardImage ||
        images.mobileCardImage ||
        images.emailGalleryImage
      ) {
        return storeImagesAsync(
          response.data._id,
          images.galleryImages,
          images.galleryImagesMobile,
          images.floorPlanImage,
          images.locationMapImage,
          images.badroomImage,
          images.bathroomImage,
          images.outspaceImage,
          images.cardImage,
          images.mobileCardImage,
          images.emailGalleryImage,
        ).then((response) => {
          return { id: id, data: response.data, status: 'OK' };
        });
      }
      return { data: response.data, status: 'OK' };
    });
  },
  updateProperty: (data: PropertyRequest, images: PropertyImagesParams) => {
    return send({
      method: 'put',
      url: `properties/${data._id}`,
      token: getToken(),
      data,
    }).then((response) => {
      if (
        images.galleryImages.length > 0 ||
        images.galleryImagesMobile.length > 0 ||
        images.floorPlanImage ||
        images.locationMapImage
      ) {
        return storeImagesAsync(
          response.data._id,
          images.galleryImages,
          images.galleryImagesMobile,
          images.floorPlanImage,
          images.locationMapImage,
          images.badroomImage,
          images.bathroomImage,
          images.outspaceImage,
          images.cardImage,
          images.mobileCardImage,
          images.emailGalleryImage,
        ).then((response) => {
          return { data: response.data, status: 'OK' };
        });
      }
      return { data: response.data, status: 'OK' };
    });
  },
  handleFreeTicket: (resource: string, params: DataProviderParamsModel) => {
    const data = {
      type: params.type,
    };
    return send({
      method: 'patch',
      url: `users/${params.id}/free-tickets-cms`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getWidgets: (fields: any) => {
    return send({
      method: 'post',
      url: `/widgets/`,
      token: getToken(),
      data: { fields },
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  createWidget: (resource: string, data: any) => {
    return send({
      method: 'post',
      url: `/widgets/create/admin`,
      token: getToken(),
      data: { data },
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  updateWidget: (id: string, data: any) => {
    return send({
      method: 'patch',
      url: `/widgets/${id}/update/admin`,
      token: getToken(),
      data: data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getRaffleTicketsReportMetadata: (userId: string, data: any) => {
    return send({
      method: 'post',
      url: `/users/${userId}/competition-tickets-metadata`,
      token: getToken(),
      data: data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getRaffleTicketsReport: (userId: string, data: any) => {
    return dataProvider
      .getRaffleTicketsReportMetadata(userId, data)
      .then((metadataResponse) => {
        return send({
          method: 'post',
          url: `/users/${userId}/competition-tickets`,
          token: getToken(),
          responseType: 'blob',
          data: data,
        }).then((response) => {
          return {
            data: response.data,
            metadata: metadataResponse.data,
          };
        });
      });
  },
  getUserOrders: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: `/users/${params.id}/orders/admin`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getWeeklySubscriptionDrawOrders: (
    resource: string,
    params: DataProviderParamsModel,
  ) => {
    return send({
      method: 'post',
      url: `/weeklySubscriptionDraws/${params.id}/orders/admin`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getWeeklySubscriptionDrawUsers: (
    resource: string,
    params: DataProviderParamsModel,
  ) => {
    return send({
      method: 'post',
      url: `/weeklySubscriptionDraws/${params.id}/users/admin`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getUserPayments: (params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: `/users/${params.id}/payments/admin`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getUserSubscriptions: (params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: `/users/${params.id}/subscriptions/admin`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  refundCheckoutPayment: (params: {
    reference: string;
    checkoutId: string;
  }) => {
    return send({
      method: 'post',
      url: `/orders/refundCheckoutByAdmin`,
      token: getToken(),
      data: { data: params },
    });
  },
  refundOldCheckoutPayment: (params: {
    reference: string;
    checkoutId: string;
  }) => {
    return send({
      method: 'post',
      url: `/orders/refundOldCheckoutByAdmin`,
      token: getToken(),
      data: { data: params },
    });
  },
  refundPayPalPayment: (params: { reference: string; paypalId: string }) => {
    return send({
      method: 'post',
      url: `/orders/refundPayPalByAdmin`,
      token: getToken(),
      data: { data: params },
    });
  },
  sendReceiptEmail: (params: { reference: string; checkoutId: string }) => {
    return send({
      method: 'post',
      url: `/orders/sendReceiptEmailByAdmin`,
      token: getToken(),
      data: { data: params },
    });
  },
  sendSubscriptionReceiptEmail: (params: {
    reference: string;
    checkoutId: string;
  }) => {
    return send({
      method: 'post',
      url: `/orders/sendSubscriptionReceiptEmailByAdmin`,
      token: getToken(),
      data: { data: params },
    });
  },
  pauseSubscription: (params: { id: string }) => {
    return send({
      method: 'patch',
      url: `/subscriptions/${params.id}/pauseByAdmin`,
      token: getToken(),
    });
  },
  unpauseSubscription: (params: { id: string }) => {
    return send({
      method: 'patch',
      url: `/subscriptions/${params.id}/unpauseByAdmin`,
      token: getToken(),
    });
  },
  cancelSubscription: (params: { id: string }) => {
    return send({
      method: 'patch',
      url: `/subscriptions/${params.id}/cancelByAdmin`,
      token: getToken(),
    });
  },
  refundBankedPayment: (params: { reference: string; amount: string }) => {
    return send({
      method: 'post',
      url: `/orders/refundBankedByAdmin`,
      token: getToken(),
      data: { data: params },
    });
  },
  getCoupons: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: resource,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getBatchCouponItems: (resource: string, data: { _id: string }) => {
    return send({
      method: 'get',
      url: `${resource}/${data._id}`,
      token: getToken(),
      data: {},
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getCharities: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: resource,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getUserCoupons: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'POST',
      url: resource,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  addCoupon: (resource: string, data: Coupon) => {
    return send({
      method: 'POST',
      url: resource,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  addCharity: (resource: string, data: Coupon) => {
    return send({
      method: 'POST',
      url: resource,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  editCoupon: (resource: string, data: Coupon) => {
    return send({
      method: 'PUT',
      url: `${resource}/${data._id}`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  editCharity: (resource: string, data: Coupon) => {
    return send({
      method: 'PUT',
      url: `${resource}/${data._id}`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  changeCouponStatus: (
    resource: string,
    data: { _id: string; isActive: boolean },
  ) => {
    return send({
      method: 'PUT',
      url: `${resource}/${data._id}`,
      token: getToken(),
      data: { isActive: data.isActive },
    }).then((response) => {
      return {
        data: response.status,
      };
    });
  },
  getCouponCountUsed: (resource: string, data: { _id: string }) => {
    return send({
      method: 'get',
      url: `${resource}/${data._id}`,
      token: getToken(),
      data: {},
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  changeCharityStatus: (
    resource: string,
    data: {
      _id: string;
      paramName: string;
      type: string;
      isActiveOnCheckoutPage: boolean;
      isActiveOnCharityPage: boolean;
    },
  ) => {
    return send({
      method: 'PUT',
      url: `${resource}/${data._id}`,
      token: getToken(),
      data: { [data.paramName]: data[data.paramName], type: data.type },
    }).then((response) => {
      return {
        data: response.status,
      };
    });
  },
  getUsersRefferalsIds: () => {
    return send({
      method: 'get',
      url: `/users/referrals`,
      token: getToken(),
      data: {},
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  setReferralsDefaultAmountNeededToSpend: (params: DataProviderParamsModel) => {
    return send({
      method: 'put',
      url: `/users/referrals`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  setReferralsDefaultAmountCredits: (params: DataProviderParamsModel) => {
    return send({
      method: 'put',
      url: `/users/referrals/credits`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getUserReferrals: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: `/users/referral/${params.id}`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data.referrals,
        total: response.data.allCount,
      };
    });
  },
  updateOrder: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'put',
      url: `/orders/${params.id}/admin`,
      token: getToken(),
      data: { paymentStatus: params.paymentStatus },
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  updateUser: (
    resource: string,
    params:
      | { oldPassword: string; newPassword: string }
      | { name: string; surname: string; email: string; skype: string },
  ) => {
    return send({
      method: 'put',
      url: `/staff/${resource}`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
  getByEmail: (email: string) => {
    return send({
      method: 'post',
      data: { data: email },
      url: `/users/email`,
      token: getToken(),
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },

  getPrizesForFilter: (data: any) => {
    return send({
      method: 'post',
      url: `prizes/filter`,
      token: getToken(),
      data,
    }).then((response) => {
      let data = response.data.prizes.map((item) => {
        item.id = item._id;
        return item;
      });
      return { data: data };
    });
  },

  addTickets: (id: string, data: any) => {
    return send({
      method: 'patch',
      url: `users/${id}/add-tickets`,
      token: getToken(),
      data,
    }).then((response) => {
      return { data: response.data };
    });
  },

  getOrders: (data) => {
    return send({
      method: 'post',
      url: `orders/details`,
      token: getToken(),
      data: data,
    }).then((response) => {
      return { data: response.data };
    });
  },

  getCompetitionDetails: (
    resource: string,
    params: DataProviderParamsModel,
  ) => {
    return send({
      method: 'post',
      url: `${resource}`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return { data: response.data };
    });
  },

  getCategories: (resource: string, params: DataProviderParamsModel) => {
    return send({
      method: 'post',
      url: `${resource}/list`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return { data: response.data.data, total: response.data.allCount };
    });
  },

  addCredits: (id: string, data: any) => {
    return send({
      method: 'patch',
      url: `credits/${id}`,
      token: getToken(),
      data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  getGeneral: () => {
    return send({
      method: 'get',
      url: `general`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },
  getAllLandingGeneral: () => {
    return send({
      method: 'get',
      url: `landing-general/all`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },
  getLandingGeneral: (type: string) => {
    return send({
      method: 'post',
      url: `landing-general/getByType`,
      token: getToken(),
      data: {
        type: type,
      },
    }).then((response) => {
      return { data: response.data };
    });
  },

  getSubscriptionModels: () => {
    return send({
      method: 'get',
      url: `subscription-models`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },
  addSubscriptionModel: (data: any) => {
    return send({
      method: 'post',
      url: `subscription-models`,
      token: getToken(),
      data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  getSubscriptionStatistics: (type: string) => {
    return send({
      method: 'POST',
      url: 'subscriptions/statistics',
      token: getToken(),
      data: {
        type: type,
      },
    });
  },
  getSubscriptionStatisticsReport: (type: string, dateFilterString: any) => {
    return send({
      method: 'GET',
      responseType: 'blob',
      url: `subscriptions/statistics/report${dateFilterString}`,
      token: getToken(),
    });
  },
  updateSubscriptionModel: (params: any) => {
    console.log(params);
    return send({
      method: 'patch',
      url: `subscription-models/${params.id}/update`,
      token: getToken(),
      data: params.data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  updateSubscriptionModelMonth: (params: any) => {
    console.log(params);
    return send({
      method: 'patch',
      url: `subscription-models/${params.id}/months/update`,
      token: getToken(),
      data: params.data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  addSubscriptionModelMonth: (params: any) => {
    console.log(params);
    return send({
      method: 'post',
      url: `subscription-models/${params.id}/months/add`,
      token: getToken(),
      data: params.data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  updateGeneral: (params: DataProviderParamsModel) => {
    return send({
      method: 'put',
      url: `general/${params.id}`,
      token: getToken(),
      data: params.data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  updateLandingGeneral: (type: string, params: DataProviderParamsModel) => {
    return send({
      method: 'put',
      url: `landing-general/${type}`,
      token: getToken(),
      data: params.data,
    }).then((response) => {
      return { data: response.data };
    });
  },
  getImages: (params) => {
    return send({
      method: 'post',
      url: `general/images`,
      token: getToken(),
      data: params,
      responseType: 'arraybuffer',
    }).then((response) => {
      return { data: response.data };
    });
  },

  createWeeklyReport: (params: ReportParams) => {
    return send({
      method: 'GET',
      url: `/reports/report-csv?isAll=${params.isAll}&startRange=${params.startRange}&endRange=${params.endRange}&competition=${params.competition}`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  createUsersReport: (params: UsersReport) => {
    return send({
      method: 'POST',
      url: `/reports/users`,
      data: params,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  createCharitiesReport: (params: ReportDateParams) => {
    return send({
      method: 'POST',
      url: `/reports/charities`,
      data: params,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  createVoucherReport: (params: ReportDateParams) => {
    return send({
      method: 'POST',
      url: `/reports/voucher`,
      data: params,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  createDailyReport: () => {
    return send({
      method: 'GET',
      url: `/reports/daily`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  createTransactionsReport: (params: ReportDateParams) => {
    return send({
      method: 'POST',
      url: `/reports/transactions`,
      data: params,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  createCouponsReport: (params: ReportDateParams) => {
    return send({
      method: 'POST',
      url: `/reports/coupons`,
      data: params,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },
  createSubscriptionsReport: (params: ReportDateParams) => {
    return send({
      method: 'POST',
      url: `/reports/subscriptions-statistic`,
      data: params,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },
  getOverviewIcons: (prizeType: 'dreamhome' | 'prize') => {
    return send({
      method: 'GET',
      url: `/properties/icons/${prizeType}`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  storeImages: (
    path: any,
    files: { images: Array<PropertyImage>; imagesMobile: Array<PropertyImage> },
  ) => {
    let imageIDS: ImageIDS = { ids: [], images: [] };
    // eslint-disable-next-line array-callback-return
    files.images.map((g, i) => {
      imageIDS.images.push(g);
      imageIDS.ids.push(`images_${i}`);
    });
    files.imagesMobile.map((g, i) => {
      imageIDS.images.push(g);
      imageIDS.ids.push(`imagesMobile_${i}`);
    });
    const multipartData = imageIDS.images.map((image, id) => {
      return { image: image, id: imageIDS.ids[id] };
    });

    return sendMultipart({
      method: 'POST',
      url: `/${path.source}/` + path.id + '/images',
      multipartData,
      token: getToken(),
    });
  },

  getReports: (params: DataProviderParamsModel) => {
    return send({
      method: 'POST',
      url: `/reports/get`,
      token: getToken(),
      data: params,
    }).then((response) => {
      return { data: response.data };
    });
  },

  downloadReport: (id: string) => {
    return send({
      method: 'POST',
      url: `/reports`,
      token: getToken(),
      data: { id },
      responseType: 'arraybuffer',
    }).then((response) => {
      return { data: response };
    });
  },

  updateMostPopular: ({
    competitionType,
    id,
    title,
  }: {
    competitionType: string;
    id: string;
    title: string;
  }) => {
    return send({
      method: 'POST',
      url: '/general/mostPopular',
      token: getToken(),
      data: { competitionType, id, title },
    }).then((response) => {
      return { data: response };
    });
  },

  addFeatured: (competitionType: string, id: string) => {
    return send({
      method: 'POST',
      url: `/general/featured`,
      token: getToken(),
      data: { competitionType, id },
    }).then((response) => {
      return { data: response };
    });
  },

  removeFeatured: (competitionType: string, id: string) => {
    return send({
      method: 'DELETE',
      url: `/general/featured/${id}`,
      token: getToken(),
    }).then((response) => {
      return { data: response };
    });
  },
  getGeneralFeaturedCompetitions: () => {
    return send({
      method: 'POST',
      url: '/general/featured/get',
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },
  getAllFeaturedCompetitions: (params = {}) => {
    return send({
      method: 'POST',
      url: 'general/all',
      token: getToken(),
      data: params,
    }).then((response) => {
      return { data: response.data };
    });
  },
  setFeaturedCompetitionsOrder: (
    featuredCompetitions: Array<{ _id: string; order: string }>,
  ) => {
    return send({
      method: 'POST',
      url: 'general/featured/order',
      token: getToken(),
      data: { featuredCompetitions: featuredCompetitions },
    }).then((response) => {
      return { data: response.data };
    });
  },

  downloadBatchFile: (resource: string, data: { id: string }) => {
    return send({
      method: 'GET',
      responseType: 'blob',
      url: `${resource}/${data.id}`,
      token: getToken(),
    }).then((response) => {
      return { data: response.data };
    });
  },

  addBonus: (resource: string, data: Bonus) => {
    return send({
      method: 'POST',
      url: `${resource}/create`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },

  editBonus: (resource: string, data: Bonus) => {
    return send({
      method: 'PUT',
      url: `${resource}/edit/${data._id}`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },

  sortCharityRandomly: (resource: string) => {
    return send({
      method: 'get',
      url: resource,
      token: getToken(),
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },

  getGeneralContent: (resource: string) => {
    return send({
      method: 'get',
      url: resource,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },

  editGeneralContent: (resource: string, data: GeneralContentItem) => {
    return send({
      method: 'PUT',
      url: `${resource}/edit/${data._id}`,
      token: getToken(),
      data,
    }).then((response) => {
      return {
        data: response.data,
      };
    });
  },
};
export default dataProvider;
